

import axios from 'axios';
const BASE_URL = process.env.REACT_APP_API_BASE_URL;

// Action Types
export const FETCH_PRODUCTS_REQUEST = 'FETCH_PRODUCTS_REQUEST';
export const FETCH_PRODUCTS_SUCCESS = 'FETCH_PRODUCTS_SUCCESS';
export const FETCH_PRODUCTS_FAILURE = 'FETCH_PRODUCTS_FAILURE';

export const CREATE_PRODUCT_REQUEST = 'CREATE_PRODUCT_REQUEST';
export const CREATE_PRODUCT_SUCCESS = 'CREATE_PRODUCT_SUCCESS';
export const CREATE_PRODUCT_FAILURE = 'CREATE_PRODUCT_FAILURE';


export const DELETE_PRODUCT_REQUEST = 'DELETE_PRODUCT_REQUEST';
export const DELETE_PRODUCT_SUCCESS = 'DELETE_PRODUCT_SUCCESS';
export const DELETE_PRODUCT_FAILURE = 'DELETE_PRODUCT_FAILURE';


export const UPDATE_PRODUCT_REQUEST = 'UPDATE_PRODUCT_REQUEST';
export const UPDATE_PRODUCT_SUCCESS = 'UPDATE_PRODUCT_SUCCESS';
export const UPDATE_PRODUCT_FAILURE = 'UPDATE_PRODUCT_FAILURE';



// Action Creators
export const fetchProductsRequest = () => ({
  type: FETCH_PRODUCTS_REQUEST,
});

export const fetchProductsSuccess = (products, pagination) => ({
  type: FETCH_PRODUCTS_SUCCESS,
  payload: { products, pagination },
});

export const fetchProductsFailure = (error) => ({
  type: FETCH_PRODUCTS_FAILURE,
  payload: error,
});

export const createProductRequest = () => ({
  type: CREATE_PRODUCT_REQUEST,
});

export const createProductSuccess = (product) => ({
  type: CREATE_PRODUCT_SUCCESS,
  payload: product,
});

export const createProductFailure = (error) => ({
  type: CREATE_PRODUCT_FAILURE,
  payload: error,
});


// Action Creators
export const deleteProductRequest = () => ({
    type: DELETE_PRODUCT_REQUEST,
  });
  
  export const deleteProductSuccess = (productId) => ({
    type: DELETE_PRODUCT_SUCCESS,
    payload: productId,
  });
  
  export const deleteProductFailure = (error) => ({
    type: DELETE_PRODUCT_FAILURE,
    payload: error,
  });

  export const updateProductRequest = () => ({
    type: UPDATE_PRODUCT_REQUEST,
  });
  
  export const updateProductSuccess = (product) => ({
    type: UPDATE_PRODUCT_SUCCESS,
    payload: product,
  });
  
  export const updateProductFailure = (error) => ({
    type: UPDATE_PRODUCT_FAILURE,
    payload: error,
  });
  


export const fetchProducts = (page, limit) => async (dispatch) => {
  dispatch(fetchProductsRequest());
  const token = localStorage.getItem('token');

  try {
    const response = await axios.get(
      `${BASE_URL}/v1/api/getAllProducts?page=${page}&limit=${limit}`,
      {
        headers: { authorization: `${token}` },
      }
    );

    const { data, meta } = response.data;

    const pagination = {
      totalItems: meta.pagination.totalProducts,
      totalPages: meta.pagination.totalPages,
      currentPage: meta.pagination.currentPage,
      limit: meta.pagination.limit,
    };

    dispatch(fetchProductsSuccess(data, pagination));
  } catch (error) {
    dispatch(fetchProductsFailure(error.message || 'Failed to fetch products.'));
  }
};

  
// Thunk to create a product
export const createProduct = (formData) => async (dispatch) => {
  dispatch(createProductRequest());
  const token = localStorage.getItem('token'); // Get token from localStorage

  try {
    const response = await axios.post(`${BASE_URL}/v1/api/createProduct`, formData, {
      headers: {
        authorization: token,
        'Content-Type': 'multipart/form-data',
      },
    });
    dispatch(createProductSuccess(response.data));
    return response.data; // Optional: return for further handling
  } catch (error) {
    dispatch(createProductFailure(error.message || 'Failed to create product.'));
    throw error; // Optional: throw for further handling
  }
};


// Thunk to delete a product



export const deleteProduct = (productId) => async (dispatch) => {
  dispatch(deleteProductRequest());
  const token = localStorage.getItem('token');

  try {
    await axios.delete(`${BASE_URL}/v1/api/deleteProduct/${productId}`, {
      headers: { authorization: token },
    });
    dispatch(deleteProductSuccess(productId));
  } catch (error) {
    dispatch(deleteProductFailure(error.message || 'Failed to delete product.'));
  }
};


export const updateProduct = (productId, productData) => async (dispatch) => {
  dispatch(updateProductRequest());

  const token = localStorage.getItem('token');

  // Remove primaryImage from the productData before sending to API
  const { primaryImage, ...updatedProductData } = productData;

  try {
    const response = await axios.put(
      `${BASE_URL}/v1/api/updateProduct/${productId}`,
      updatedProductData,
      {
        headers: {
          authorization: token,
          'Content-Type': 'multipart/form-data',
        },
      }
    );
    dispatch(updateProductSuccess(response.data));
    return response.data;
  } catch (error) {
    dispatch(updateProductFailure(error.message || 'Failed to update product.'));
    throw error;
  }
};
